import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h4 className="footer-title">Dr. BhuPat Pharma</h4>
          <p className="footer-description">
            Dedicated to women's health and wellness through innovative pharmaceutical solutions.
          </p>
          <div className="social-linksf">
            <a href="#" className="social-linkf" aria-label="Facebook"><FaFacebookF  size={20} color='#3e9ed8'/></a>
            <a href="#" className="social-linkf" aria-label="Twitter"><FaTwitter  size={20} color='#3e9ed8'/></a>
            <a href="https://www.linkedin.com/company/drbhupatpharma/" className="social-linkf" aria-label="LinkedIn"><FaLinkedinIn size={20} color='#3e9ed8' /></a>
            <a href="#" className="social-linkf" aria-label="Instagram"><FaInstagram  size={20} color='#3e9ed8'/></a>
          </div>
        </div>
        <div className="footer-column">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
            <li><Link to="/products" className="footer-link">Our Products</Link></li>
            <li><Link to="/career" className="footer-link">Careers</Link></li>
            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
          </ul>
        </div>
      <div className="footer-column">
  <h4 className="footer-title">Contact Info</h4>
  <address className="contact-info">
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaMapMarkerAlt /></span>
<a 
    className="contact-link" 
    href="https://maps.google.com/?q=BS-1,+Ground+floor,+Manik+Arcade,+Chetana+Nagar,+Kalda+Corner,+Chhatrapati+Sambhajinagar,+Maharashtra+431005" 
    target="_blank" 
    rel="noopener noreferrer"
>
    BS-1, Ground floor, Manik Arcade, Chetana Nagar, Kalda Corner, Chhatrapati Sambhajinagar, Maharashtra 431005
</a>
    </p>
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaPhone /></span>
      <a className="contact-link" href="tel:+918850694241">+91 8850-694241</a>
    </p>
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaEnvelope /></span>
      <a className="contact-link" href="mailto:Info@drbhupatpharma.com">Info@drbhupatpharma.com</a>
    </p>
  </address>
</div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Dr. BhuPat Pharma Private Limited. All Rights Reserved.  </p>
        <p><a href='https://acenurture.com/'>Developed by Acenurture </a></p>
      </div>
    </footer>
  );
};

export default Footer;